import React from "react";
import {Stack, Text, StackProps} from "@chakra-ui/core";

import Heading from "~/ui/display/Heading";
import Content from "~/ui/structure/Content";
import {useTranslation} from "~/i18n/hooks";

const PlansHero: React.FC<StackProps> = (props) => {
  const t = useTranslation();

  return (
    <Content
      backgroundColor="primary.100"
      paddingBottom={{base: 6, md: 20}}
      paddingX={6}
      {...props}
    >
      <Stack
        shouldWrapChildren
        color="white"
        flex={1}
        margin="auto"
        maxWidth={850}
        paddingTop={{base: 6, md: 20}}
        spacing={10}
        textAlign={{base: "left", md: "center"}}
      >
        <Stack spacing={6}>
          <Heading as="h2" color="primary.900" fontSize={{base: "4xl", md: "5xl"}}>
            {t("faqs.hero.title")}
          </Heading>
          <Text as="h3" color="primary.500" fontSize={{base: "md", md: "lg"}}>
            {t("faqs.hero.subtitle")}
          </Text>
        </Stack>
      </Stack>
    </Content>
  );
};

export default PlansHero;
